import FastValueViewer from 'components/ScalarSpreadsheet/utilities/FastValueViewer';
import { Cell } from 'components/Spreadsheet/components';
import { TotalsColumnProps } from './TotalsColumn.props';
import { StyledTotalsColumn } from './TotalsColumn.styles';

const TotalsColumn = ({ className = '', data }: TotalsColumnProps) => (
  <StyledTotalsColumn
    data={data}
    className={className}
    cellRenderer={Cell}
    valueViewer={FastValueViewer}
  />
);

export default TotalsColumn;
